const TONE_BY_STATUS: Record<string, 'success' | 'warning' | 'critical' | ''> = {
  DELIVERED: 'success',
  AWAITING_FINAL_RESOLUTION: 'warning',
  DELIVERY_ATTEMPT_FAILED: 'warning',
  RETURN_INITIATED: 'warning',
  RETURN_IN_TRANSIT: 'warning',
  RETURNED_TO_ORIGIN: ''
};

export function StatusBadge({ status, label }: { status: string; label: string }) {
  const tone = TONE_BY_STATUS[status] ?? '';
  return <span className={`status-badge ${tone}`}>{label}</span>;
}
